import { NativeModules } from 'react-native';
import { safeParse } from './safeParse';
const { KIDBridge } = NativeModules;
const widgets = new Map();
const icons = new Map();
const colors = new Map();
// 获取组件资源
const getCachedComponentStyleConfig = (kid) => {
    var _a;
    if (!kid || typeof kid !== 'string')
        return null;
    if (!widgets.has(kid)) {
        widgets.set(kid, (_a = KIDBridge === null || KIDBridge === void 0 ? void 0 : KIDBridge.getComponentStyleConfig) === null || _a === void 0 ? void 0 : _a.call(KIDBridge, kid));
    }
    return safeParse(widgets.get(kid));
};
// 获取图标
const getCachedIconColorConfig = (kid) => {
    var _a;
    if (!kid || typeof kid !== 'string')
        return null;
    if (!icons.has(kid)) {
        icons.set(kid, (_a = KIDBridge === null || KIDBridge === void 0 ? void 0 : KIDBridge.getIconColorConfig) === null || _a === void 0 ? void 0 : _a.call(KIDBridge, kid));
    }
    return safeParse(icons.get(kid));
};
// 获取颜色
const getCachedColorConfig = (kid) => {
    var _a;
    if (!kid || typeof kid !== 'string')
        return null;
    if (!colors.has(kid)) {
        colors.set(kid, (_a = KIDBridge === null || KIDBridge === void 0 ? void 0 : KIDBridge.getColorConfig) === null || _a === void 0 ? void 0 : _a.call(KIDBridge, kid));
    }
    return safeParse(colors.get(kid));
};
export { getCachedComponentStyleConfig, getCachedIconColorConfig, getCachedColorConfig };
